import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "edit-organizations"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Voltar", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "spacing" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Status"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_7 = { for: "stats" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_9 = ["disabled"]

import { computed, onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { OrganizationModel } from '@/models/OrganizationModel'
import { toast } from 'vue3-toastify'
import { AxiosResponse } from 'axios'
import OrganizationStatusEnum from '@/enums/OrganizationStatusEnum'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import { user } from '@/global/states/GlobalState'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditOrganizationView',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props
const axios = useAxios()
const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const payload = ref<Partial<OrganizationModel>>({})
const isUpdatingOrganization = ref(false)

function updateOrganization () {
  isUpdatingOrganization.value = true

  axios.put('/api/organizations', { ...payload.value, status: payload.value.status ? OrganizationStatusEnum.ACTIVE : OrganizationStatusEnum.INACTIVE, organization_ids: [payload.value.id] })
    .then(() => {
      toast.success(isChamber.value ? 'Câmara editada com sucesso' : 'Setor editado com sucesso')
    })
    .finally(() => isUpdatingOrganization.value = false)
}

function getOrganization () {
  axios.get(`/api/organizations/${props.id}`)
    .then((res: AxiosResponse<OrganizationModel>) => {
      payload.value = { ...res.data, status: res.data.status == OrganizationStatusEnum.ACTIVE }
    })
}

onMounted(() => {
  getOrganization()
})

return (_ctx: any,_cache: any) => {
  return (payload.value.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          label: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
          class: "back"
        }, _hoisted_4),
        _createElementVNode("section", null, [
          _createElementVNode("h1", null, [
            _createElementVNode("strong", null, "Crie um " + _toDisplayString(isChamber.value ? 'câmara' : 'setor'), 1),
            _createTextVNode(" (obrigatório)")
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Ex: Secretaria de Segurança e Trânsito",
            name: "name",
            id: "namet",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.name) = $event))
          }, null, 512), [
            [_vModelText, payload.value.name]
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h1", null, [
            _createElementVNode("strong", null, "Iniciais do " + _toDisplayString(isChamber.value ? 'câmara' : 'setor'), 1),
            _createTextVNode(" (obrigatório)")
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Ex: S.M.S.T",
            name: "acronym",
            id: "acronym",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.acronym) = $event))
          }, null, 512), [
            [_vModelText, payload.value.acronym]
          ])
        ]),
        _createElementVNode("section", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("label", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "stats",
              id: "stats",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.status) = $event))
            }, null, 512), [
              [_vModelCheckbox, payload.value.status]
            ]),
            _hoisted_8
          ])
        ]),
        _createElementVNode("nav", null, [
          (!isUpdatingOrganization.value)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                value: "Salvar",
                onClick: updateOrganization,
                disabled: !payload.value.name || !payload.value.acronym
              }, null, 8, _hoisted_9))
            : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                key: 1,
                height: 60,
                maxWidth: 464
              })),
          _createElementVNode("input", {
            type: "button",
            value: "Cancelar",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'admin.home' })))
          })
        ])
      ]))
    : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
}
}

})